import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Title, TitleUpsert } from "../../_objects/title";
import { TitleService } from "../http-api/title.service";

@Injectable({
  providedIn: 'root'
})
export class TitlesStateService {
  private titleSubject = new BehaviorSubject<Title>({
    createDate: "",
    createdBy: "",
    id: "",
    isDeleted: false,
    isValid: false,
    items: [],
    lastUpdateDate: "",
    lastUpdatedBy: "",
    schemaVersion: ""
  });
  public titles$ = this.titleSubject.asObservable();
  public titleItems$ = this.titles$.pipe(map(t => t.items));

  constructor(private titleService: TitleService) {
  }

  public fetchAndUpdate() {
    this.titleService
      .getTitles()
      .subscribe(data => this.titleSubject.next(data));
  }

  public upsertTitle(titleUpsert: TitleUpsert): Observable<Title> {
    return this.titleService.upsertTitle(titleUpsert)
      .pipe(tap(data => this.titleSubject.next(data)));
  }
}
